module.exports = __webpack_public_path__ + "media/styles/images/png/check-teal-8087b005cb56f0baac7e42380557003e.png";